import request from '@/utils/request'
import requestCamera from '@/utils/requestCamera'

const url1 = 'elevator'
const url2 = 'camera'
const elevatorSensorUrl = 'elevator/sensor'

/** 获取电梯列表 */
export function searchElevator(data) {
  return request({
    url: `${url1}/searchElevator`,
    method: 'post',
    data,
  })
}

/** 获取电梯列表(根据当前用户进行筛选) */
export function searchElevatorByUserId(data) {
  return request({
    url: `${url1}/searchElevatorByUserId`,
    method: 'post',
    data,
  })
}

/** 获取抠图配置列表列表 */
export function searchImageRecognitionMattingConfigPage(data) {
  return request({
    url: `${url1}/getImageRecognitionMattingConfigPage`,
    method: 'post',
    data,
  })
}

/** 获取电梯列表 */
export function deviceList(data) {
  return request({
    url: `${url1}/deviceList/${data}`,
    method: 'get',
    data,
  })
}

/** 获取电梯列表 */
export function searchElevatorNotPage(data) {
  return request({
    url: `${url1}/searchElevatorNotPage`,
    method: 'post',
    data,
  })
}
/** 获取电梯列表 */
export function searchElevatorDownload(data) {
  return request({
    url: `${url1}/test`,
    method: 'post',
    responseType: 'blob',
    data,
  })
}

/** 获取电梯详情 */
export function getElevatorDetail(data) {
  return request({
    url: `${url1}/${data}`,
    method: 'get',
  })
}

/** 获取电梯监控画面Url  */
export function getElevatorMonitorUrl(data) {
  return request({
    url: `${url2}/${data}`,
    method: 'get',
  })
}

/** 获取电梯监控画面Url  */
export function getElevatorPreviewUrl(data) {
  return requestCamera({
    url: `cameraResource/getPreviewURL`,
    method: 'post',
    data,
  })
}

/** 获取电梯监控画面Url TOKEN  */
export function getElevatorMonitorUrlEzopenToken(data) {
  return request({
    url: `${url2}/ezopenToken`,
    method: 'get',
  })
}

/** 获取电梯监控画面展示字段  */
export function getPageDisplay(elevatorCode) {
  return request({
    url: `${elevatorSensorUrl}/pageDisplay/${elevatorCode}`,
    method: 'get',
  })
}

/** 获取电梯数量  */
export function countElevator(data) {
  return request({
    url: `${url1}/countElevator`,
    method: 'get',
  })
}

/** 供编辑使用的详情查询  */
export function getElevatorInfo(data) {
  return request({
    url: `${url1}/getElevatorInfo/${data}`,
    method: 'get',
  })
}

/** 电梯编辑  */
export function editElevatorInfo(data) {
  return request({
    url: `${url1}/editElevatorInfo`,
    method: 'post',
    data,
  })
}

/** 添加电梯  */
export function addElevatorInfo(data) {
  return request({
    url: `${url1}/addElevatorInfo`,
    method: 'post',
    data,
  })
}

/** 获取电梯图片  */
export function getElevatorImg(data) {
  return request({
    url: `${url1}/getElevatorImg/${data}`,
    method: 'post',
  })
}

/** 删除文件 */
export function deleteElevatorImg(elevatorId, fileId) {
  return request({
    url: `${url1}/deleteElevatorImg/${elevatorId}/${fileId}`,
    method: 'post',
  })
}

/** 设置楼层信息(包含额定速度信息) */
export function updateFloorElevator(data) {
  return request({
    url: `${url1}/updateFloorElevator`,
    method: 'post',
    data,
  })
}

/** 设置楼层信息 */
export function getElevatorDeviceDetailList(elevatorId) {
  return request({
    url: `${url1}/deviceDetailList/${elevatorId}`,
    method: 'get',
  })
}

/** 初始化统计数据 */
export function initInstallTime(elevatorId) {
  return request({
    url: `${url1}/initInstallTime/${elevatorId}`,
    method: 'get',
  })
}

/** 删除数据 */
export function initElevator(elevatorId) {
  return request({
    url: `${url1}/initElevator/${elevatorId}`,
    method: 'get',
  })
}

/** 删除数据 */
export function refreshCamera(elevatorCode) {
  return request({
    url: `${url1}/refresh/camera/${elevatorCode}`,
    method: 'get',
  })
}

export function deleteElevatorId(elevatorCode) {
  return request({
    url: `${url1}/deleteElevatorId/${elevatorCode}`,
    method: 'get',
  })
}

export function getElevatorHeatMapStatistics(data) {
  return request({
    url: `${url1}/elevatorHeatMapNew`,
    method: 'post',
    data,
  })
}

/** 获取电梯列表 */
export function logPicture(data) {
  return request({
    url: `${url1}/logPicture/${data}`,
    method: 'get',
    data,
  })
}
/** 调用统计数据接口 */
export function getElevatorRunDataStatistics(data) {
  return request({
    url: `${url1}/getElevatorRunDataStatistics`,
    method: 'post',
    data,
  })
}

// 夜间守护
export function nightWatch(data) {
  return request({
    url: `${url1}/night-watch/list-by-elevator-code/${data}`,
    method: 'get',
    data,
  })
}

// 保存电梯取证配置信息
export function saveEvidence(data) {
  return request({
    url: `${url1}/group-leasing/save-evidence`,
    method: 'post',
    data,
  })
}

// 根据电梯楼层获取成功的记录
export function listSuccess(data) {
  return request({
    url: `${url1}/group-leasing/list-success-download-records`,
    method: 'post',
    data,
  })
}

// 获取群组楼层信息，取证信息
export function listGroupLeasingFloors(data) {
  return request({
    url: `${url1}/group-leasing/list-group-leasing-floors/${data}`,
    method: 'get',
    data,
  })
}
// 获取群组可疑楼层
export function listFloorSuspicious(data) {
  return request({
    url: `${url1}/group-leasing/list-floor-suspicious/${data}`,
    method: 'get',
    data,
  })
}

// 获取群组取证配置信息
export function listFloorEvidence(data) {
  return request({
    url: `${url1}/group-leasing/list-floor-evidence/${data}`,
    method: 'get',
    data,
  })
}

/** 获取电梯列表 */
export function devicePingQuality(data) {
  return request({
    url: `device/devicePingQuality/${data}`,
    method: 'get',
    data,
  })
}

/** 获取电信通话参数 */
export function getCameraVoiceInfo(elevatorCode) {
  return requestCamera({
    url: `voice/wss-info-by-elevator-code/${elevatorCode}`,
    method: 'get',
  })
}


/** 清除记录 */
export function delFaultAndStatisticsByElevatorCode(data) {
  return request({
    url: `${url1}/delFaultAndStatisticsByElevatorCode `,
    method: 'post',
    data
  })
}

/** 导入电梯 */
export function importElevator(data) {
  return request({
    url: `${url1}/import-elevator-excel/${data.projectId}`,
    method: 'post',
  })
}

// 批量更新
export function batchEditElevatorInfo(data) {
  return request({
    url: `${url1}/batchEditElevatorInfo`,
    method: 'post',
    data
  })
}
